import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import  {Navigation}  from "./components/index.js";
import { Landing, Research, Teaching, Writing, Projects, Art } from "./routes/index.js";
import "./core-ui/Styles.sass";
import './routes/about/About.sass'
import './core-ui/Hover.sass'
import './routes/landing/Landing.sass'
import './routes/portfolio/Portfolio.sass'
import './components/footer/Footer.sass'
import './components/navigation/Navigation.sass'

const App = () => {
    return (
        <Router>
        <Navigation />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/research" element={<Research />} />
          <Route path="/teaching" element={<Teaching />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/code" element={<Projects />} />
          <Route path="/art" element={<Art />} />
        </Routes>
      </Router>
    );
  };

  export default App;